// CitySelect.tsx
import useCountries from "hooks/useCountries";
import React from "react";
import Select from "react-select";

interface CitySelectProps {
  value: any;
  onChange: (value: any) => void;
  country: any;
}

const CitySelect: React.FC<CitySelectProps> = ({ value, onChange, country }) => {
  const { getStatesByCountry } = useCountries();
  const cities = getStatesByCountry(country.label);

  return (
    <div className="z-[49]">
      <Select
        placeholder="Anywhere"
        options={cities}
        value={value}
        onChange={(value: string) => onChange(value)}
        formatOptionLabel={(option: any) => (
          <div className="flex flex-row items-center gap-3 z-50">
            {/* <div>{option.flag}</div> */}
            <div className="text-[#111827] z-50">
              {option.name}
              <span className="text-neutral-500 ml-1">{/* {option.region} */}</span>
            </div>
          </div>
        )}
        classNames={{
          control: () => "p-3 border-2",
          input: () => "text-lg",
          option: () => "text-lg",
        }}
        theme={(theme: any) => ({
          ...theme,
          borderRadius: 6,
          colors: {
            ...theme.colors,
            primary: "#1f4c6f",
            primary25: "#ffe4e6",
          },
        })}
        styles={{
          option: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: state.isFocused ? "#ffffff" : "transparent", // Change background color when option is focused
            color: state.isSelected ? "white" : "#111827", // Change text color when option is selected
            "&:hover": {
              backgroundColor: "#f0f0f0", // Change background color on hover
            },
          }),
        }}
      />
    </div>
  );
};

export default CitySelect;
